export default __webpack_public_path__ + "static/media/large.71f299cc.jpg";